import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const LanguageContainer = styled.div`
  position: relative;
  margin-left: 2px;
`;

const LanguageButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme.colors.light};
  cursor: pointer;
  padding: 8px 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const Dropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  background: ${props => props.theme.colors.dark};
  border: 1px solid ${props => props.theme.colors.primary};
  border-radius: 4px;
  padding: 4px 0;
  display: ${props => props.isOpen ? 'block' : 'none'};
  z-index: 1000;
`;

const LanguageOption = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme.colors.light};
  cursor: pointer;
  padding: 8px 10px;
  align-items: center;
  width: 100%;
  text-align: left;
  font-size: 14px;
  
  &:hover {
    background: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.primary};
  }
`;

const LanguageSwitch: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang).then(() => {
      localStorage.setItem('i18nextLng', lang);
      setIsOpen(false);
    });
  };

  return (
    <LanguageContainer>
      <LanguageButton onClick={() => setIsOpen(!isOpen)}>
        {t(`common.language.${i18n.language}`)}
        <span>▼</span>
      </LanguageButton>
      <Dropdown isOpen={isOpen}>
        <LanguageOption onClick={() => handleLanguageChange('en')}>
          {t('common.language.en')}
        </LanguageOption>
        <LanguageOption onClick={() => handleLanguageChange('zh')}>
          {t('common.language.zh')}
        </LanguageOption>
      </Dropdown>
    </LanguageContainer>
  );
};

export default LanguageSwitch; 